import { unwrap } from 'api/schema/utils';
import ImagePlaceholder from 'images/icons/document_image_placeholder.png';
import parseFiles from 'parsers/parseFiles';
import env from 'utils/env';
import parseComponent from './parseComponent';
import parseModelProjection from './parseModelProjection';
export default function parseSpecificationDocument(data) {
    var _a, _b, _c, _d, _e, _f;
    if (!data)
        return;
    const { fancyName: title, itemCode: code, image, description, author: _author, folder: _folder, sizeStandard: _sizeStandard, sizes: _sizes, colors: _colors, tags: _tags, status: _status, state: _state, projections: _projections, season: _season, category: _category, persons: _persons, brand: _brand, components: _components, elements: _elements, variants: _variants, specificationTeamMembersNode, } = data.node;
    const author = _author === null || _author === void 0 ? void 0 : _author.firstName;
    const folder = _folder === null || _folder === void 0 ? void 0 : _folder.name;
    const mainPhoto = image ? `${env.static}/${image}` : ImagePlaceholder;
    const sizeStandard = _sizeStandard === null || _sizeStandard === void 0 ? void 0 : _sizeStandard.name;
    const sizes = ((_a = unwrap(_sizes)) === null || _a === void 0 ? void 0 : _a.map((node) => {
        var _a;
        return ({
            id: node.id,
            isActive: node.isActive,
            name: (_a = node.sizeName) === null || _a === void 0 ? void 0 : _a.name,
        });
    })) || [];
    const colors = ((_b = unwrap(_colors)) === null || _b === void 0 ? void 0 : _b.filter((node) => node.isActive)) || [];
    const tags = ((_c = unwrap(_tags)) === null || _c === void 0 ? void 0 : _c.map((node) => { var _a; return ({ id: node.id, name: (_a = node.tag) === null || _a === void 0 ? void 0 : _a.name }); })) || [];
    const status = _status === null || _status === void 0 ? void 0 : _status.name;
    const projections = ((_d = unwrap(_projections)) === null || _d === void 0 ? void 0 : _d.map((node) => parseModelProjection(node))) || [];
    const season = _season === null || _season === void 0 ? void 0 : _season.name;
    const state = _state;
    const category = _category === null || _category === void 0 ? void 0 : _category.name;
    const brand = _brand === null || _brand === void 0 ? void 0 : _brand.name;
    const components = ((_e = unwrap(_components)) === null || _e === void 0 ? void 0 : _e.filter(Boolean).map((node) => node && parseComponent(node)).filter(Boolean)) || [];
    const persons = unwrap(_persons) || [];
    const files = parseFiles(data === null || data === void 0 ? void 0 : data.node);
    const specificationElements = ((_f = unwrap(_elements)) === null || _f === void 0 ? void 0 : _f.map((node) => (Object.assign(Object.assign({}, node), { elementSizes: unwrap(node === null || node === void 0 ? void 0 : node.elementSizes) || [] })))) || [];
    const elements = [];
    specificationElements.forEach((element, i) => {
        elements.push({ id: element === null || element === void 0 ? void 0 : element.id, name: element === null || element === void 0 ? void 0 : element.name, elementSizes: [] });
        sizes.forEach((size) => {
            const elementSize = element.elementSizes.find((elemSize) => { var _a; return ((_a = elemSize === null || elemSize === void 0 ? void 0 : elemSize.modelSpecificationSize) === null || _a === void 0 ? void 0 : _a.id) === size.id; });
            elements[i].elementSizes = [...elements[i].elementSizes, elementSize];
        });
    });
    const specificationVariants = unwrap(_variants) || [];
    const variants = [];
    colors.forEach((color, i) => {
        variants.push({ id: color.id, name: color.name, quantities: [] });
        sizes.forEach((size) => {
            const specificationVariant = specificationVariants.find((variant) => { var _a, _b; return ((_a = variant === null || variant === void 0 ? void 0 : variant.color) === null || _a === void 0 ? void 0 : _a.id) === color.id && ((_b = variant === null || variant === void 0 ? void 0 : variant.size) === null || _b === void 0 ? void 0 : _b.id) === size.id; });
            variants[i].quantities = [...variants[i].quantities, specificationVariant];
        });
    });
    return {
        title,
        code,
        description,
        footer: {
            author,
            folder,
            code,
            model: title,
        },
        mainPhoto,
        sizeStandard,
        sizes,
        state,
        colors,
        tags,
        status,
        projections,
        persons,
        season,
        specificationTeamMembersNode,
        category,
        brand,
        components,
        elements,
        variants,
        files,
    };
}
